import { LitElement, html, css } from 'lit';
import './DashboardMenu.js';

class DashboardHeader extends LitElement {
  static styles = css`
    .header {
      display: flex;
      background-color: #111827; /* 深みのある濃いネイビー/黒 */
      padding: 0 24px;
      justify-content: space-between;
      align-items: center;
      position: sticky;
      top: 0;
      z-index: 1000;
      height: 64px;
      border-bottom: 1px solid #1f2937;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
    }

    .header-left {
      display: flex;
      align-items: center;
    }
    
    .logo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1.5px solid #374151;
      margin-right: 14px;
    }

    /* タイトル（Wendy One） */
    .title-text {
      color: #ffffff;
      font-family: 'Wendy One', sans-serif;
      font-size: 20px;
      line-height: 1;
      letter-spacing: 0.5px;
    }

    /* ルビの見やすさ改善 */
    ruby {
      ruby-position: over;
      ruby-align: center;
    }

    rt {
      font-family: 'Meiryo', 'Yu Gothic', sans-serif;
      font-size: 11px;
      font-weight: 600;
      color: #cbd5e1; /* 明るめのグレー */
      letter-spacing: 0.2em;
      margin-bottom: 4px;
      text-shadow: 0 1px 2px rgba(0,0,0,0.5);
    }

    /* メニューを囲む枠（案2のスタイルを改良） */
    .header-right {
      background-color: rgba(255, 255, 255, 0.05); /* わずかに背景を明るく */
      padding: 4px 10px;
      border-radius: 12px;
      border: 1px solid rgba(255, 255, 255, 0.1); /* 繊細な白い枠線 */
      display: flex;
      align-items: center;
    }

    /* モバイル用のレスポンシブ調整 */
    @media (max-width: 480px) {
      .header {
        padding: 0 12px;
      }
      .logo {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
      .title-text {
        font-size: 22px;
      }
      .header-right {
        padding: 2px 6px;
      }
    }
    
    a {
      text-decoration: none;
      outline: none;
      display: flex;
      align-items: center;
    }
  `;

  /**
   * テキストクリック時のリロード制御
   */
  _handleReload(e) {
    // すでにダッシュボードのトップ（パラメータなし）にいる場合は、強制的にリロードを実行します
    if (window.location.pathname === '/' && !window.location.search) {
      e.preventDefault();
      window.location.reload();
    }
  }

  render() {
    const loginCookieName = process.env.LOGIN_COOKIE_NAME;
    const isLogin = document.cookie.split(';').some((item) => item.trim().startsWith(loginCookieName + '='));

    return html`
      <div class="header">
        <div class="header-left">
            <a href="${process.env.BRAND_URL_BASE || '#'}" target="_blank" rel="noopener noreferrer">
              <img class="logo" alt="Pwappy logo" src="/misc/logo.png">
            </a>
            
            <a href="/" @click="${this._handleReload}">
              <div class="title">
                <div class="title-text">
                  <ruby>
                    ${process.env.SITE_NAME}
                    <rt>プワッピー</rt>
                  </ruby>
                </div>
              </div>
            </a>
        </div>
        ${isLogin ? html`
        <div class="header-right">
          <dashboard-menu></dashboard-menu>
        </div>
        ` : ''}
      </div>
    `;
  }
}

customElements.define('dashboard-header', DashboardHeader);